exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.max-w460[data-v-9e0388d6] {\r\n  max-width: 460px;\n}\n.operation-wrap[data-v-9e0388d6] {\r\n  margin-bottom: 12px;\r\n  font-size: 13px;\r\n  color: #606266;\r\n  line-height: 1.6;\n}\r\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/setting/message/settings/AppPush.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;CAClB;AACD;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;CAClB","file":"AppPush.vue","sourcesContent":["\n.max-w460[data-v-9e0388d6] {\r\n  max-width: 460px;\n}\n.operation-wrap[data-v-9e0388d6] {\r\n  margin-bottom: 12px;\r\n  font-size: 13px;\r\n  color: #606266;\r\n  line-height: 1.6;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9e0388d6","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/setting/message/settings/AppPush.vue
// module id = ORmW
// module chunks = 0